import {v1_config} from '@app/v1_integration';
import {Environment} from '.';

export const environment: Environment = {
  ///////////
  // BEGIN: SPA v1 configurations

  ...v1_config,

  // Overwrite v1_config settings as needed
  // ex:
  // appName: "Pulse 2.x"

  // END: SPA v1 configurations
  ///////////

  ///////////
  // BEGIN: SPA v2 specific configurations

  appRoot: 'https://pulse-res-dev.idtech.com/zigzag_v2/latest/',

  production: false,

  enableRouteTracing: false,

  pulse1x_PublicUrl_SPA_API: v1_config.pulse1x_PublicUrl + '/api/pulsespa',

  jobAppMyAccountUrl: v1_config.WWW_UrlRoot + `/account#/term-staff`,

  jobAppLogoutRedirectUrl: v1_config.WWW_UrlRoot + `/account#/logout`,

  // END: SPA v2 specific configurations
  ///////////
  reCAPTCHAKey: '6LdteDEUAAAAAEvwhARiWG7POjZJlXJx9xyVrhYw',

  service_error:
    'We are experiencing some technical difficulties.  Please retry later or contact customer service for assistance. <a href="https://help.idtech.com/">iD Tech Help Center</a><br /> <a style="white-space:nowrap;" href="tel:+18887098324">1-888-709-8324</a>'
};
